import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "prompt-content__title" }, /*#__PURE__*/_toDisplayString('你不是该空间成员'), -1)
const _hoisted_2 = { class: "prompt-content__tips" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "prompt-content__tips--text" }, /*#__PURE__*/_toDisplayString('当前账号：'), -1)
const _hoisted_4 = { class: "account-info" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "account-info__nickname--suffix" }
const _hoisted_7 = { class: "prompt-content__button" }

import { NAvatar } from 'naive-ui'
import { useAccountChange } from '@teams/common/hooks/useAccountChange'
import ChangeAccountBtn from '@teams/common/components/changeAccountBtn'

import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'loginPrivateNotMember',
  setup(__props) {

const { currentAccountInfo } = useAccountChange()
const { t } = useI18n()
const $tt = (key: string, ...params: any[]) => {
  // @ts-ignore
  return t(`components.dialog.forbiddenJoin.${key}`, ...params)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(NAvatar), {
          round: "",
          size: 24,
          src: _unref(currentAccountInfo)?.pic
        }, null, 8, ["src"]),
        _createElementVNode("span", {
          class: "account-info__nickname",
          title: _unref(currentAccountInfo)?.nickname
        }, _toDisplayString(_unref(currentAccountInfo)?.nickname), 9, _hoisted_5),
        _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(currentAccountInfo)?.is_company_account ? '(企业账号)' : '(个人账号)'), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_unref(ChangeAccountBtn), {
        btnText: $tt('okText'),
        isShowRectangle: false,
        scrollbarStyle: {
        maxHeight: '280px',
        marginTop: '4px'
      },
        type: "default",
        itemStyle: { margin: '2px 4px' },
        popoverStyle: { width: '296px' }
      }, null, 8, ["btnText"])
    ])
  ], 64))
}
}

})